export const ORDER_RECEIVED_END_TIME = "orderReceivedEndTime";
export const ORDER_RECEIVED_START_TIME = "orderReceivedStartTime";
export const EXPECTED_DELIVERY_AT = "expectedDeliveryAt";
export const ALERT_MESSAGE_START_TIME =
  "Start Date Time or End Date Time cannot be less than the current date time";
export const ALERT_MESSAGE_END_TIME =
  "End time cannot be lesser than Start time";
export const ALERT_MESSAGE_EXPECTED_DELIVERY_DATE =
  "Expected delivery date cannot not be less than End Time";
export const DELIVERY_CONFIG_SUCCESSFUL = "Delivery configuration successful!";
export enum DELIVERY_DATE_STATUS {
  "CUSTOM" = "CUSTOM",
  "DEFAULT" = "DEFAULT",
}
